module.exports = __webpack_public_path__ + "img/info.e4717560.png";